import Axios from 'axios'
import _get from 'lodash/get'

import { bugsnagNotify } from '../trip-dashboard/bugsnag/bugsnag'

const baseUrl = '/api/v1/user-actions'

const axios = Axios.create({})

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    console.error(error)
    bugsnagNotify(error)
    if (_get(error, 'response.status') === 401 || _get(error, 'response.status') === 419) {
      alert('Session has expired! You will be redirected to login.')
      window.location.href = '/login'
    } else {
      alert('An error occurred. You will be redirected to login.')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

class UserActivityController {
  static ping(userId, userActionTypeId, userActionData) {
    UserActivityController.postPing(userId, userActionTypeId, userActionData)
  }

  static postPing(userId, userActionTypeId, userActionData) {
    axios
      .post(`${baseUrl}/ping/${userId}`, {
        user_action_type_id: userActionTypeId,
        user_action_data: userActionData
      })
      .then(res => {
        if (res.status === 200) {
          // console.log('Pinged');
        }
      })
  }
}

export { UserActivityController }
